<template>
    <v-container
        >
        <v-img
            v-if="image != ''"
            :src="image"
            :width="size + 'px'"
            ></v-img>
    </v-container>
</template>

<script>
    import axios from "axios";
    import { EventBus } from "@/event-bus";
    import { scrollUpdater } from "../mixins/scrollUpdater";
    import { appCaller } from "../mixins/appCaller";
    import { requestTools } from "../mixins/requestTools";

    export default {
        name: "UiImageCond",

        props: {
            uiId: Number,
            size: Number,
            value: String
        },

        mixins: [appCaller, requestTools],

        components: {
        },

        data: function () {
            return {
                image: "",
                rootApi: process.env.VUE_APP_ROOT_API
            };
        },

        created: function () {
        },

        mounted: function () {
            //Atualiza informações da tela quando evento for disparado.
            this.appCallerListenEventByLevel(this.$updNowLevels.level1, function () {
                this.updateAll();
            }.bind(this));
        },

        methods: {

            updateAll: function () {
                this.getImageCond();
            },

            getImageCond: async function () {

                if (!this.uiId || (this.value + "").trim() == "") {
                    return;
                }

                const url = this.rootApi + "/uicondexec/" + this.uiId + "/" + this.value;
                console.log(url);
                const conds = await this.requestGet(url);
                for (let i in conds) {
                    const cond = conds[i];
                    if (!cond.isTrue || !cond.image) {
                        continue;
                    }
                    //console.log("uicondexec", this.uiId, this.value, cond);
                    this.image = cond.image;
                }
            }
        }
    };
</script>

<style scoped>

</style>
